export const SNACKBAR_AUTO_HIDE_DURATION = 6000;
export const SCROLLABLE_PAGE_DETAIL_CONTAINER_ID =
  "scrollable-container-page-detail";
